import { render } from "./PopoverContent.vue?vue&type=template&id=4e2c7554&ts=true"
import script from "./PopoverContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopoverContent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/popover/PopoverContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e2c7554"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e2c7554', __exports__)) {
    api.reload('4e2c7554', __exports__)
  }
  
  module.hot.accept("./PopoverContent.vue?vue&type=template&id=4e2c7554&ts=true", () => {
    api.rerender('4e2c7554', render)
  })

}


export default __exports__